import React from "react";
import PageContainer from "../../components/common/PageContainerAuth";
import ProductsSection from "../../components/pages/Products/ProductsSection";

export default function Products() {
    return (
        <PageContainer section="parameters-articles" pageTitle="Articles">
            <ProductsSection />
        </PageContainer>
    );
}
